import { VisitSignalsPayload } from '../analytics/behaviour/snapshot';
import { ensureCsrfToken } from './csrf';

const PATH = '/api/visit-signals';

/**
 * Sends one behaviour snapshot. Telemetry, fire and forget.
 *
 * `keepalive` is what makes the send on the way out arrive at all — the leave beacon in
 * `visitOutcome` relies on the same property. `navigator.sendBeacon` is deliberately not a fallback:
 * it cannot carry the CSRF header, and dropping the guard from a writing route to accommodate it
 * would be the wrong trade. A snapshot lost to a failed request costs nothing, because snapshots are
 * cumulative — the next one carries everything again.
 *
 * The awaited token is always already cached by the time any behaviour exists: the page's first
 * transaction read is a POST and has long since run. So the await resolves in the same tick and does
 * not outlive the page.
 */
export const sendVisitSignals = async (
  uuid: string,
  payload: VisitSignalsPayload,
): Promise<void> => {
  try {
    const token = await ensureCsrfToken();
    const request = window.fetch(PATH, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': token },
      body: JSON.stringify({ uuid, ...payload }),
    });
    if (request && typeof request.catch === 'function') request.catch(() => undefined);
  } catch {
    // telemetry must never break the page
  }
};
